(function (window, document) {
  'use strict';

  var loader = document.currentScript;
  var menImageSrc = loader ? loader.getAttribute('data-men-image-src') : '';
  var womenImageSrc = loader ? loader.getAttribute('data-women-image-src') : '';
  var menLogoSrc = loader ? loader.getAttribute('data-men-logo-src') : '';

  window.SlipstreamKiwiSizeChartEnhancementRegistry = {
    charts: [
      {
        id: 'men',
        enabled: true,
        popupSelector: '.kiwi-sizing-modal',
        kiwiWatermark: 'POWERED BY KIWI SIZING',
        tableHeaders: {
          imperial: ['SIZE', 'HEIGHT (FT)', 'WEIGHT (LBS)', 'CHEST (IN)', 'WAIST (IN)'],
          metric: ['SIZE', 'HEIGHT (CM)', 'WEIGHT (KG)', 'CHEST (CM)', 'WAIST (CM)']
        },
        tableSignature: {
          imperial: ['XS', '5\'3"-5\'7"', '110-120', '31.1-33.4', '26-28.3'],
          metric: ['XS', '160-175', '50-55', '79-85', '66-72']
        },
        imageSrc: menImageSrc,
        logoSrc: menLogoSrc,
        headerTitle: 'Men’s Prime Aero Short Sleeve Jersey Size Charts',
        units: {
          imperial: {
            label: 'IN / LBS',
            measurements: ['1.Chest: 38.2in', '2.Waist: 33in', '3.Hips: 36.2in'],
            description: 'The table reflects the fit for a model who is 5\'11" tall and weighs 163 lb, wearing size M-XL.'
          },
          metric: {
            label: 'CM / KG',
            measurements: ['1.Chest: 97cm', '2.Waist: 84cm', '3.Hips: 92cm'],
            description: 'The table reflects the fit for a model who is 180 cm tall and weighs 74 kg, wearing size M-XL.'
          }
        },
        fit: [
          ['M', 'Race fit'],
          ['L', 'Moderate Compression'],
          ['XL', 'Relaxed Fit']
        ]
      },
      {
        id: 'women',
        enabled: true,
        popupSelector: '.kiwi-sizing-modal',
        kiwiWatermark: 'POWERED BY KIWI SIZING',
        tableHeaders: {
          imperial: ['SIZE', 'HEIGHT (FT)', 'WEIGHT (LBS)', 'CHEST (IN)', 'WAIST (IN)'],
          metric: ['SIZE', 'HEIGHT (CM)', 'WEIGHT (KG)', 'CHEST (CM)', 'WAIST (CM)']
        },
        tableSignature: {
          imperial: ['XXS', '4\'9"-5\'2"', '99-110', '28.7-31.1', '23.6-26'],
          metric: ['XXS', '150-160', '45-50', '73-79', '58-63']
        },
        imageSrc: womenImageSrc,
        logoSrc: menLogoSrc,
        headerTitle: 'Women’s Prime Long Sleeve Jersey Size Charts',
        units: {
          imperial: {
            label: 'IN / LBS',
            measurements: ['1.Chest: 34.6in', '2.Waist: 30.7in', '3.Hips: 35.4in'],
            description: 'The table reflects the fit for a model who is 5′6″ tall and weighs 132 lb, wearing size XXS-S.'
          },
          metric: {
            label: 'CM / KG',
            measurements: ['1.Chest: 88cm', '2.Waist: 78cm', '3.Hips: 90cm'],
            description: 'The table reflects the fit for a model who is 168 cm tall and weighs 60 kg, wearing size XXS-S.'
          }
        },
        fit: [
          ['XXS', 'Race fit'],
          ['XS', 'Moderate Compression'],
          ['S', 'Relaxed Fit']
        ]
      }
    ]
  };
})(window, document);
